import { render } from "./ActivityLogoutAlertModal.vue?vue&type=template&id=052b4dde&scoped=true"
import script from "./ActivityLogoutAlertModal.vue?vue&type=script&lang=js"
export * from "./ActivityLogoutAlertModal.vue?vue&type=script&lang=js"

import "./ActivityLogoutAlertModal.vue?vue&type=style&index=0&id=052b4dde&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052b4dde"]])

export default __exports__